export const ACTIONS_BY_ROLES = {
    user: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
    region: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
    business: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
    
    template: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
    logo: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
    
    style: {
        list: {
            create: ['Admin'],
        },
        detail: {
            save: ['Admin'],
        }
    },
      
    section: {
        list: {
            create: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
        },
        detail: {
            save: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
            duplicate: ['Author'],
        }
    },
    snippet: {
        list: {
            create: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
        },
        detail: {
            save: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
            duplicate: ['Author'],
        }
    },
    document: {
        list: {
            create: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
            send_review: ['Author'],
            review: ['Reviewer'],
            publish: ['Publisher'],
            download: ['Admin', 'Author', 'Publisher', 'Reviewer'],
        },
        detail: {
            save: ['Author'],
            preview: ['Admin', 'Author', 'Publisher', 'Reviewer'],
            save_send: ['Author'],
            duplicate: ['Author'],
            reject: ['Reviewer'],
            approve: ['Reviewer'],
            publish: ['Publisher'],
            obsolete: ['Author'],
            downloadWord: ['Admin', 'Author', 'Publisher', 'Reviewer'],
            downloadPDF: ['Admin', 'Author', 'Publisher', 'Reviewer'],
        }
    },
};